export const SquareIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <g clipPath="url(#clip0_1710_612)">
    <path d="M4 1C4 0.446875 3.55312 0 3 0C2.44688 0 2 0.446875 2 1V2H1C0.446875 2 0 2.44688 0 3C0 3.55312 0.446875 4 1 4H2V12C2 13.1031 2.89687 14 4 14H11V12H4V1ZM12 15C12 15.5531 12.4469 16 13 16C13.5531 16 14 15.5531 14 15V14H15C15.5531 14 16 13.5531 16 13C16 12.4469 15.5531 12 15 12H14V4C14 2.89687 13.1031 2 12 2H5V4H12V15Z" fill="#64748B"/>
  </g>
  <defs>
    <clipPath id="clip0_1710_612">
      <rect width="16" height="16" fill="white"/>
    </clipPath>
  </defs>
</svg>
)